<template>
  <!-- 发起竞猜弹窗 -->
  <el-dialog title="" :visible.sync="visible" class="send-match-dialog-components" :close-on-click-modal="false" :before-close="close" :show-close="true" width="450px">
    <div slot="title" class="title">发起鹰选</div>
    <div class="content">
      <div class="padding-b-20">
        <el-form :model="ruleForm_One" :rules="rules" ref="ruleForm_One" label-width="100px" class="demo-ruleForm">
          <el-form-item label="选择分类" prop="category_id">
            <el-select size="small" v-model="ruleForm_One.category_id" placeholder="请选择分类">
              <el-option :label="item.name" v-for="item in categoryList" :key="item.category_id" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="选择问题" prop="q_id">
            <el-select size="small" v-model="ruleForm_One.q_id" placeholder="主队能获胜吗？A能 & B不能">
              <el-option v-for="item in questionList" :key="item.id" :label="item.title" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="封盘时间" prop="duration">
            <div class="flex-row">
              <el-input style="width: 80px" size="small" type="number" v-model="ruleForm_One.duration"></el-input>
              <div style="padding-left: 10px; color: #666666">/分钟之后</div>
            </div>
          </el-form-item>
        </el-form>
        <div class="flex-middle">
          <div class="content-btn flex-middle" @click="commit('ruleForm_One')">立即开始</div>
        </div>
      </div>

      <!-- 
			<div class="padding-b-20">
				<el-form :model="ruleForm_Two" :rules="rules" ref="ruleForm_Two" label-width="100px" class="demo-ruleForm">
					<el-form-item label="选额分类" prop="category_id">
						<el-select size="small" v-model="ruleForm_Two.category_id" placeholder="请选择分类">
							<el-option :label="item.name" v-for="(item,index) in categoryList" :key="item.category_id"
								:value="item.id"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="选择问题" prop="q_id">
						<el-select size="small" v-model="ruleForm_Two.q_id" placeholder="主队能获胜吗？A能 & B不能">
							<el-option v-for="(item,index) in questionList" :key="item.id" :label="item.title" :value="item.id"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="封盘时间" prop="duration">
						<div class="flex-row">
							<el-input style="width:80px" size="small" type="number" v-model="ruleForm_Two.duration"></el-input>
							<div style="padding-left:10px;color:#666666;">/分钟之后</div>
						</div>
					</el-form-item>
				</el-form>
				<div class="flex-middle">
					<div class="content-btn flex-middle" @click="commit('ruleForm_Two')">立即开始</div>
				</div>
			</div>

			<div class="padding-b-20">
				<el-form :model="ruleForm_Three" :rules="rules" ref="ruleForm_Three" label-width="100px" class="demo-ruleForm">
					<el-form-item label="选额分类" prop="category_id">
						<el-select size="small" v-model="ruleForm_Three.category_id" placeholder="请选择分类">
							<el-option :label="item.name" v-for="(item,index) in categoryList" :key="item.category_id"
								:value="item.id"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="选择问题" prop="q_id">
						<el-select size="small" v-model="ruleForm_Three.q_id" placeholder="主队能获胜吗？A能 & B不能">
							<el-option v-for="(item,index) in questionList" :key="item.id" :label="item.title" :value="item.id"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="封盘时间" prop="duration">
						<div class="flex-row">
							<el-input style="width:80px" size="small" type="number" v-model="ruleForm_Three.duration"></el-input>
							<div style="padding-left:10px;color:#666666;">/分钟之后</div>
						</div>
					</el-form-item>
				</el-form>
				<div class="flex-middle">
					<div class="content-btn flex-middle" @click="commit('ruleForm_Three')">立即开始</div>
				</div>
			</div>
			-->

      <div class="content-tip flex-middle">注意：竞猜发起后立即开盘，不可取消不可修改， 若需作废 请联系管理员</div>
    </div>
  </el-dialog>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { post } from "../../util/http";
export default {
  computed: {
    ...mapState(["userInfo", "appConfig"]),
  },
  props: {
    live_id: {
      type: [Number, String],
      default: "",
    },
  },

  data() {
    var checkDuration = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入分钟"));
      }
      value = Number(value);
      setTimeout(() => {
        if (!Number.isInteger(value)) {
          callback(new Error("分钟必须位数字"));
        } else {
          if (value < 10) {
            callback(new Error("不得少于10分钟"));
          } else {
            callback();
          }
        }
      }, 30);
    };
    return {
      visible: false,
      categoryList: [],
      questionList: [],
      ruleForm_One: {
        category_id: "",
        q_id: "",
        duration: "",
      },
      ruleForm_Two: {
        category_id: "",
        q_id: "",
        duration: "",
      },
      ruleForm_Three: {
        category_id: "",
        q_id: "",
        duration: "",
      },
      rules: {
        category_id: [
          {
            required: true,
            message: "请选择分类",
            trigger: "change",
          },
        ],
        q_id: [
          {
            required: true,
            message: "请选择问题",
            trigger: "change",
          },
        ],
        duration: [
          {
            validator: checkDuration,
            trigger: "change",
          },
        ],
      },
    };
  },
  created() {},
  destroyed() {},
  methods: {
    open() {
      this.visible = true;
      this.getCategoryList();
      this.getQuestionList();
    },
    close() {
      this.visible = false;
      this.$refs.ruleForm_One.resetFields();
      //this.$refs.ruleForm_Two.resetFields();
      //this.$refs.ruleForm_Three.resetFields();
    },
    getCategoryList() {
      let data = {};
      post({
        url: "/api/live/getCategory",
        data,
      }).then(({ data: { data } }) => {
        // console.log("data: ",data);
        this.categoryList = data || [];
        // console.log("this.pendingMatch: ",this.pendingMatch);
        // this.loading = false;
      });
    },

    getQuestionList() {
      let data = {
        anchor_id: this.userInfo.id,
        status: 2,
        page: 1,
        size: 99,
      };
      // console.log(data)
      post({
        url: "/api/guess/getQuestionList",
        data,
      })
        .then(({ data: { data } }) => {
          const list = data?.question ?? ["", ""];
          list.forEach((v) => {
            v.contentArr = v.content?.split("|");
          });
          // console.log("list: ",list);
          this.questionList = list;
          // this.$emit('backCount', data.count)
        })
        .catch((err) => {
          console.warn("getQuestionList err: ", err);
        });
    },

    commit(ruleform = "") {
      if (!ruleform) {
        return;
      }
      this.$refs[ruleform].validate((valid) => {
        // console.log("this.ruleForm: ",this.ruleForm);
        if (valid) {
          let data = {
            anchor_id: this.userInfo.id,
            category_id: this[ruleform].category_id,
            duration: Number(this[ruleform].duration),
            live_id: this.live_id,
            q_id: this[ruleform].q_id,
          };
          post({
            url: "/api/guess/createGuess",
            data,
          })
            .then(({ data: { data, status = "" } }) => {
              // console.log("data: ",data);
              if (status == 0) {
                this.$message({
                  message: "发起成功",
                  type: "success",
                  customClass: "ly-success",
                });
                this.$emit("refresh");
              } else {
                this.$message({
                  message: "发起失败",
                  type: "error",
                  customClass: "ly-error",
                });
              }
              this.$refs[ruleform].resetFields();
              this.close();
            })
            .catch((err) => {
              console.warn("createGuess err: ", err);
            });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style scoped lang="stylus">
.send-match-dialog-components {
	z-index: 1;
	border-radius: 8px;

	.title {
		color: #333333;
		font-size: .16rem;
	}

	.content {

		.content-btn {
			background: linear-gradient(90deg, #29F19C 0%, #02A1F9 100%);
			border-radius: 5px;
			width: 1.71rem;
			height: 35px;
			color: #ffffff;
			margin: .1rem;
			cursor: pointer;
		}
	}

	.dialog-footer_one>div {
		height: 40px;
		background: #26D99D;
		border-radius: 20px;
		margin: .2rem;
	}

	.content-tip {
		color: #3C9CFE;
		margin: .3rem 0rem;
		font-size: .1rem;
	}

	/deep/ {
		@import "../../assets/common-dialog-1.css";
		.el-form-item {
			margin-bottom: 10px;
		}

		.el-input--small .el-input__icon {
			line-height: 40px;
		}
	}

}
</style>
